import { WhatsAppWabaStatus } from '@/types';

export const WhatsAppWabaStatusColorMap = {
    [WhatsAppWabaStatus.ACTIVE]: 'emerald',
    [WhatsAppWabaStatus.READY]: 'yellow',
    [WhatsAppWabaStatus.AWAITING_ACTIVATION]: 'yellow',
    [WhatsAppWabaStatus.DISCONNECTED]: 'gray',
};
